import { render } from "./Mb010.vue?vue&type=template&id=da8fcae8"
import script from "./Mb010.vue?vue&type=script&lang=js"
export * from "./Mb010.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__